import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import { NavControlGroup } from 'components/navigation/common'
import { namespace } from 'modules/Notifications/localization'
import { NavigationLink } from './NotificationsTabs.styled'

const { Typography } = common

const I18_PATH = `${namespace}:notifications`

export enum NotificationsTab {
  Read = 'Read',
  Unread = 'Unread',
}

type NotificationsTabsProps = {
  activeTab: NotificationsTab
  onChange: (value: NotificationsTab) => void
}

type NotificationTabItemProps = NotificationsTabsProps & {
  type: NotificationsTab
  title: string
}

const NotificationTabItem: React.FC<NotificationTabItemProps> = ({
  activeTab,
  title,
  type,
  onChange,
}) => {
  function handleTabClick() {
    onChange(type)
  }

  return (
    <NavigationLink
      isActive={activeTab === type}
      onClick={handleTabClick}
      data-test={`NotificationTabItem${type}`}
    >
      <Typography variant='h4'>{title}</Typography>
    </NavigationLink>
  )
}

const NotificationsTabs: React.FC<NotificationsTabsProps> = ({ activeTab, onChange }) => {
  const { t } = useTranslation()
  const TABS = [
    {
      title: t(`${I18_PATH}.unread`, { count: 5 }),
      type: NotificationsTab.Unread,
    },
    {
      title: t(`${I18_PATH}.read`, { count: 20 }),
      type: NotificationsTab.Read,
    },
  ]

  return (
    <NavControlGroup>
      {TABS.map(({ title, type }) => (
        <NotificationTabItem
          key={type}
          title={title}
          type={type}
          activeTab={activeTab}
          onChange={onChange}
        />
      ))}
    </NavControlGroup>
  )
}

export default NotificationsTabs
